import { Header } from "semantic-ui-react";

import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import db from "astrid-firebase/src/db";
import costCategories from "astrid-firestore/src/api/costs/constants/costCategories";

import CollectionDataTable from "../../../ui/components/CollectionDataTable/CollectionDataTable";

import CostsActions from "../../../costs/components/CostsActions/CostsActions";

import useCloudRevenuesColumns from "./hooks/useCloudRevenuesColumns";

// Selected revenues become one sales order per producer and publisher.
export default function SuperAdminCloudRevenuesView() {
	const { t } = useTranslation();
	const navigate = useNavigate();

	// Equality filters only, so no composite index is needed; the table sorts.
	const query = useMemo(
		() =>
			db
				.collection("costs")
				.where("category", "==", costCategories.CLOUD)
				.where("deleted", "==", false)
				.where("processed", "==", false)
				.where("orderId", "==", null),
		[],
	);

	const columns = useCloudRevenuesColumns();

	return (
		<>
			<Header as="h2">{t("unprocessedCloudRevenues", "Unprocessed cloud revenues")}</Header>

			<CollectionDataTable
				persist
				selectable
				filterable
				query={query}
				columns={columns}
				onClick={({ id, firstParty }) => navigate(`/producer/${firstParty.id}/finance/revenues/${id}`)}
				sortBy={{ id: "created", desc: true }}
				footer={<CostsActions expense={false} redirectTo="/admin/finance/sales-orders" />}
			/>
		</>
	);
}
